import "./ToolbarDebugView.less";
import React from 'react';
import classNames from 'classnames';

export function ToolbarDebugView({ store }) {
	/** @type {Draft.EditorState} */
	const editorState = store.getEditorState();
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();

	const env = store.getEditorEnviorment();

	const focusKey = selection.getFocusKey();
	const startKey = selection.getStartKey();
	const startOffset = selection.getStartOffset();
	const startBlock = content.getBlockForKey(startKey);

	let body = (
		<Block
			key="start"
			env={env}
			block={startBlock}
			focused={focusKey === startKey}
			offset={startOffset}>
		</Block>
	);
	if (!selection.isCollapsed()) {
		const endKey = selection.getEndKey();
		const endOffset = selection.getEndOffset();
		const endBlock = content.getBlockForKey(endKey);
		body = [
			body,
			<br key="wrap" />,
			<Block key="end" block={endBlock} focused={focusKey === endKey} offset={endOffset}></Block>
		];
	}

	return (
		<div className="toolbar-debug-view">
			{body}
		</div>
	)
}

function Block(props) {
	/** @type {Draft.ContentBlock} */
	const block = props.block;
	const env = props.env;
	const focused = props.focused;
	const offset = props.offset;

	if (!block) {
		return <span className="empty-block">Empty</span>;
	}

	return (
		<span className={classNames('content-block', block.getType(), { focused })}>
			{env || ''} [{block.getType()}: {block.getKey()} {offset}/{block.getLength()}]
		</span>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/debugPlugin/ToolbarDebugView.jsx